import { __ } from '@wordpress/i18n';
import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { BigLoader } from '../gutenberg/src/icons';
import { Button } from '@wordpress/components';
import MediaUpload from './MediaUpload';

const Integrations = () => {
	const [integrationactivation, seIntegrationactivation] = useState(true);
	const [loading, setLoading] = useState(true);
	const [integrations, setIntegrations] = useState([]);
	const [activated, setActivated] = useState(0);
	const [configPopShown, setConfigPopShown] = useState(null);
	const [activeMultiselect, setActiveMultiselect] = useState('');
	const [syncedToday, setSyncedToday] = useState(0);

	useEffect(() => {
		loadIntegration();
	}, []);

	useEffect(() => {
		let count = 0;
		let submit_on_date = [0];
		integrations.map((integration) => {
			let configured = true;
			Object.values(integration.config).map((config) => {
				if (config.value == '') {
					configured = false;
				}
			});
			integration.activated && configured ? count++ : count;
			submit_on_date.push(
				integration.submit_on_date?.[new Date().toISOString().slice(0, 10)]
					? integration.submit_on_date[new Date().toISOString().slice(0, 10)]
					: 0
			);
		});
		setActivated(count);
		setSyncedToday(submit_on_date.reduce((a, b) => Math.max(a, b)));
	}, [integrations]);

	const activateIntegration = async (e) => {
		setConfigPopShown(
			integrations.find((integration) => integration.key === e.target.value)
		);
	};

	const deactivateIntegration = async () => {
		setLoading(true);
		const rawResponse = await fetch(
			`${easy_email_integration.ajaxurl}/eei/v1/integrations/deactivate/${configPopShown.key}`,
			{
				method: 'PUT',
			}
		);

		const response = await rawResponse.json();
		setIntegrations(response);
		setConfigPopShown(null);
		setLoading(false);
	};

	const loadIntegration = async () => {
		setLoading(true);
		const response = await fetch(`${easy_email_integration.ajaxurl}/eei/v1/integrations`);
		if (response.status !== 'error') {
			const data = await response.json();
			setIntegrations(data);
			setConfigPopShown(
				data.find((integration) => {
					let configured = true;
					Object.values(integration.config).map((config) => {
						if (config == '') {
							configured = false;
						}
					});
					return integration.activated && !Boolean(configured);
				})
			);
		} else {
			setNotification({
				status: 'error',
				message: __(
					'Sorry, there was some error loading data',
					'easy-email-integration'
				),
			});
		}
		setLoading(false);
	};

	const handleConfigPopClose = (e) => {
		if (e.target.classList.contains('configuration-window') || e.target.classList.contains('close-wrapper')) {
			setConfigPopShown(null);
		}
	};

	const configUpdateHandler = async (e) => {
		e.preventDefault();
		setLoading(true);
		const rawResponse = await fetch(
			`${easy_email_integration.ajaxurl}/eei/v1/integrations/config/${configPopShown.key}`,
			{
				method: 'PUT',
				body: JSON.stringify(configPopShown.config),
			}
		);

		const response = await rawResponse.json();
		setIntegrations(response);
		setConfigPopShown(null);
		setLoading(false);
	};

	const configChangeHandler = (e) => {
		{
			let newfields = {
				...configPopShown.config[e.target.name],
				value: e.target.value,
			};
			let newConfig = { ...configPopShown.config, [e.target.name]: newfields };
			setConfigPopShown({
				...configPopShown,
				config: newConfig,
			});
		}
	};

	const multiselectChangeHandler = (field, value) => {
		let savedValue = configPopShown.config[field].value;
		if (savedValue.includes(value)) {
			savedValue.splice(savedValue.indexOf(value), 1);
		} else {
			savedValue.push(value);
		}
		let newfields = {
			...configPopShown.config[field],
			value: savedValue,
		};
		let newConfig = { ...configPopShown.config, [field]: newfields };
		setConfigPopShown({
			...configPopShown,
			config: newConfig,
		});
	};

	/**
	 * Check If Integration activate or not with activation list
	 */
	const getActiveIntegration = [];
	{integrations?.map((integration) => {
		let configured = true;
			Object.values(integration.config).map((config) => {
				if (config.value == '') {
					configured = false;
				}
			});
		if(	integration.activated && configured ){
			getActiveIntegration.push(integration.name)
		}
	})}

	/* {integrations?.map((integration) => {
		console.log(integration.activated)//
	})} */

	return (
		<div>
			<h2 className="title">{__('Integrations', 'easy-email-integration')}</h2>
			<div className="option-form-field-wrap">
				<div className="easy_email_integration-integrations-field">
					{loading && (
						<div className="eei-loader">
							<BigLoader />
						</div>
					)}
					<div className="easy_email_integration-row">
						<div className="easy_email_integration-col-6">
							<div className="easy_email_integration-available-integrations">
								<div className="easy_email_integration-col-headings">
									<h4>
										{__('Available Apps', 'easy-email-integration')}
										<span>{integrations.length - activated}</span>
									</h4>
									<p className='eei_integration_heading'>
										{__(
											"The plugin integrates with most popular email and data collection clients. Check the following list and instantly connect your preferred client.",
											'easy-email-integration'
										)}
									</p>
									{integrations?.map((integration) => {
										let configured = true;
										Object.values(integration.config).map((config) => {
											if (config.value == '') {
												configured = false;
											}
										});
										if (!integration.activated || (!configured && integration.key != 'fluentcrm' && integration.key != 'mailpoet')) {
											return (
												<label className="integration" key={integration.key}>
														<input
															type="checkbox"
															name="select_int"
															value={integration.key}
															onClick={activateIntegration}
														/>
														<span
															className="integration_icon"
															dangerouslySetInnerHTML={{
																__html: integration.icon,
															}}
														></span>
														<span className="integration_name">
															{integration.name}
														</span>
														<svg
															className="add-icon"
															xmlns="http://www.w3.org/2000/svg"
															viewBox="0 0 24 24"
														>
															<path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
														</svg>
													</label>
											);
										}
									})}
								</div>
							</div>
						</div>
						<div className="easy_email_integration-col-6">
							<div className="easy_email_integration-connected-integrations">
								<div className="easy_email_integration-col-headings">
									<h4>
										{__('Connected', 'easy-email-integration')}
										<span>{activated}</span>
											<small className="">
												{syncedToday}
												{__(
													' leads has been collected today!',
													'easy-email-integration'
												)}
											</small>
									</h4>
									
									<p style={{ minHeight: 65 }}>
										{__(
											"The following clients have been already integrated for lead collection. Click on the Settings icon to update the integration settings",
											'easy-email-integration'
										)}
									</p>
									{/* activated app show */}
									{integrations?.map((integration) => {
										if (integration.activated) {
											let configured = true;
											Object.values(integration.config).map((config) => {
												if (config.value == '') {
													configured = false;
												}
											});

											if (!configured && integration.key != 'fluentcrm' && integration.key != 'mailpoet') {
												return false;
											}

											return (
												<label
													className={`integration ${integration.error
															? 'integration-configuration-needed'
															: ''
														}`}
													key={integration.key}
												>
													<input
														type="checkbox"
														name="config_int"
														value={integration.key}
														onClick={() => {
															setConfigPopShown(integration);
														}}
													/>
													<span
														className="integration_icon"
														dangerouslySetInnerHTML={{
															__html: integration.icon,
														}}
													></span>
													<span className="integration_name">
														{integration.name}
														{integration.error ?
															<span className="eei-sync-status eei-sync-status-error">
																<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.001 10h2v5h-2zM11 16h2v2h-2z" /><path d="M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z" /></svg>
																<span>{__('Error', 'easy-email-integration')}</span>
															</span>
															: 
															<span className="eei-sync-status">
																<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 305.002 305.002">
																	<g>
																		<path d="M152.502,0.001C68.412,0.001,0,68.412,0,152.501s68.412,152.5,152.502,152.5c84.089,0,152.5-68.411,152.5-152.5    S236.591,0.001,152.502,0.001z M152.502,280.001C82.197,280.001,25,222.806,25,152.501c0-70.304,57.197-127.5,127.502-127.5    c70.304,0,127.5,57.196,127.5,127.5C280.002,222.806,222.806,280.001,152.502,280.001z" />
																		<path d="M218.473,93.97l-90.546,90.547l-41.398-41.398c-4.882-4.881-12.796-4.881-17.678,0c-4.881,4.882-4.881,12.796,0,17.678    l50.237,50.237c2.441,2.44,5.64,3.661,8.839,3.661c3.199,0,6.398-1.221,8.839-3.661l99.385-99.385    c4.881-4.882,4.881-12.796,0-17.678C231.269,89.089,223.354,89.089,218.473,93.97z" />
																	</g>
																</svg>
																<span>{__('Collecting', 'easy-email-integration')}</span>
															</span>
														}
													</span>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 50 50"
														className="config-icon"
													>
														<path d="M47.16,21.221l-5.91-0.966c-0.346-1.186-0.819-2.326-1.411-3.405l3.45-4.917c0.279-0.397,0.231-0.938-0.112-1.282 l-3.889-3.887c-0.347-0.346-0.893-0.391-1.291-0.104l-4.843,3.481c-1.089-0.602-2.239-1.08-3.432-1.427l-1.031-5.886 C28.607,2.35,28.192,2,27.706,2h-5.5c-0.49,0-0.908,0.355-0.987,0.839l-0.956,5.854c-1.2,0.345-2.352,0.818-3.437,1.412l-4.83-3.45 c-0.399-0.285-0.942-0.239-1.289,0.106L6.82,10.648c-0.343,0.343-0.391,0.883-0.112,1.28l3.399,4.863 c-0.605,1.095-1.087,2.254-1.438,3.46l-5.831,0.971c-0.482,0.08-0.836,0.498-0.836,0.986v5.5c0,0.485,0.348,0.9,0.825,0.985 l5.831,1.034c0.349,1.203,0.831,2.362,1.438,3.46l-3.441,4.813c-0.284,0.397-0.239,0.942,0.106,1.289l3.888,3.891 c0.343,0.343,0.884,0.391,1.281,0.112l4.87-3.411c1.093,0.601,2.248,1.078,3.445,1.424l0.976,5.861C21.3,47.647,21.717,48,22.206,48 h5.5c0.485,0,0.9-0.348,0.984-0.825l1.045-5.89c1.199-0.353,2.348-0.833,3.43-1.435l4.905,3.441 c0.398,0.281,0.938,0.232,1.282-0.111l3.888-3.891c0.346-0.347,0.391-0.894,0.104-1.292l-3.498-4.857 c0.593-1.08,1.064-2.222,1.407-3.408l5.918-1.039c0.479-0.084,0.827-0.5,0.827-0.985v-5.5C47.999,21.718,47.644,21.3,47.16,21.221z M25,32c-3.866,0-7-3.134-7-7c0-3.866,3.134-7,7-7s7,3.134,7,7C32,28.866,28.866,32,25,32z" />
													</svg>
													{integration.error && <p className="eei-upgrade-notice"><svg viewBox="0 0 45.311 45.311" fill="#D3455B"><path d="m22.675.02-.02.001-.02-.001C10.135.02 0 10.154 0 22.656c0 12.5 10.135 22.635 22.635 22.635h.04c12.5 0 22.635-10.135 22.635-22.635C45.311 10.154 35.176.02 22.675.02zm0 38.791-.02-.001-.02.001a3.705 3.705 0 1 1 0-7.408h.04a3.705 3.705 0 1 1 0 7.408zm5.313-28.233c-.242 3.697-1.932 14.692-1.932 14.692 0 1.854-1.519 3.356-3.373 3.356h-.058c-1.853 0-3.372-1.504-3.372-3.356 0 0-1.689-10.995-1.931-14.692-.12-1.851 1.298-5.288 5.304-5.288l.029.001.029-.001c4.005 0 5.425 3.437 5.304 5.288z"></path></svg><span>{integration.error}</span></p>}
												</label>
											);
										}
									})}
								</div>
							</div>
						</div>
					</div>
					{configPopShown !== null && configPopShown !== undefined && (
						<div
							className="configuration-window"
							onClick={handleConfigPopClose}
						>
							<form className="configuration-popup" onSubmit={configUpdateHandler}>
								<div className="close-wrapper" onClick={handleConfigPopClose}>
									<span className="dashicons dashicons-no-alt"></span>
								</div>
								<div
									className="configuration-header"
									style={{ backgroundColor: configPopShown.color }}
								>
									<div
										className="integration_icon"
										dangerouslySetInnerHTML={{
											__html: configPopShown.icon,
										}}
									></div>
								</div>
								{Object.entries(configPopShown.config).length > 0 ? (
									<React.Fragment>
										{configPopShown.key === 'fluentcrm' && (
											<React.Fragment>
												{Boolean(eei.fluentcrm_activated) ? (
													<React.Fragment>
														<div className="configuration-subheader">
															<h4>
																{__('Configure', 'easy-email-integration')}{' '}
																{configPopShown.name}
															</h4>
															<p
																dangerouslySetInnerHTML={{
																	__html: configPopShown.desc,
																}}
															></p>
														</div>
														<div className="configuration_fields">
															{Object.entries(configPopShown.config).map(
																(field) => (
																	<React.Fragment>
																		{field[1].type === 'multiselect' ? (
																			<React.Fragment>
																				<label className="multiselect">
																					{field[1].label}
																					{field[1].tip && (
																						<React.Fragment>
																							<div
																								className="eei-tooltip"
																								data-place="right"
																								data-offset="{'top': 20, 'right': 20, 'bottom':  20, 'left': 20}"
																								data-multiline={true}
																								data-tip={field[1].tip}
																							>
																								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330">
																									<g>
																										<path d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992     C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008     s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z" />
																										<path d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983     C180,136.725,173.284,130.008,165,130.008z" />
																										<path d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61     c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61     C172.81,71.61,168.95,70.011,165,70.011z" />
																									</g>
																								</svg>
																							</div>
																							<ReactTooltip />
																						</React.Fragment>
																					)}
																					{field[1].desc && (
																						<small dangerouslySetInnerHTML={{
																							__html: field[1].desc,
																						}}></small>
																					)}
																				</label>
																				<div className="multiselect-wrapper">
																					<div
																						className={`multiselect-inputmock ${activeMultiselect === field[0]
																								? 'active'
																								: ''
																							}`}
																						onClick={(e) =>
																							setActiveMultiselect((prev) =>
																								Boolean(prev) ? '' : field[0]
																							)
																						}
																					>
																						{configPopShown.config[field[0]].value
																							.length
																							? configPopShown.config[
																								field[0]
																							].value.map((item) => (
																								<span>
																									{field[0] === 'tags' && (
																										<React.Fragment>
																											{
																												eei.fluentcrm_tags.find(
																													(tag) =>
																														item === tag.id
																												).title
																											}
																										</React.Fragment>
																									)}
																									{field[0] === 'lists' && (
																										<React.Fragment>
																											{
																												eei.fluentcrm_lists.find(
																													(list) =>
																														item === list.id
																												).title
																											}
																										</React.Fragment>
																									)}
																								</span>
																							))
																							: field[1].placeholder}
																					</div>
																					{field[0] === 'tags' && (
																						<ul
																							className={`multiselect-options ${activeMultiselect &&
																									activeMultiselect === field[0]
																									? 'active'
																									: ''
																								}`}
																						>
																							{eei.fluentcrm_tags.map((tag) => (
																								<li
																									key={tag.id}
																									onClick={() => {
																										multiselectChangeHandler(
																											field[0],
																											tag.id
																										);
																										setActiveMultiselect('');
																									}}
																								>
																									{tag.title}
																								</li>
																							))}
																						</ul>
																					)}
																					{field[0] === 'lists' && (
																						<ul
																							className={`multiselect-options ${activeMultiselect &&
																									activeMultiselect === field[0]
																									? 'active'
																									: ''
																								}`}
																						>
																							{eei.fluentcrm_lists.map((list) => (
																								<li
																									key={list.id}
																									onClick={() => {
																										multiselectChangeHandler(
																											field[0],
																											list.id
																										);
																										setActiveMultiselect('');
																									}}
																								>
																									{list.title}
																								</li>
																							))}
																						</ul>
																					)}
																				</div>
																			</React.Fragment>
																		) : (
																			<label>
																				{field[1].label}
																				<input
																					type="text"
																					name={field[0]}
																					placeholder={field[1].placeholder}
																					value={
																						configPopShown.config[field[0]].value
																					}
																					onChange={configChangeHandler}
																					required
																				/>
																			</label>
																		)}
																	</React.Fragment>
																)
															)}
						
															<div className="text-right">
																{/* "found" : "Not found"} */}
																{getActiveIntegration.includes(configPopShown.name) === true ? 
																<button
																	type="button"
																	className="disableConfig"
																	onClick={deactivateIntegration}
																>
																	{__('Disable', 'easy-email-integration')}
																</button>
																:""}
																
																<button
																	type="submit"
																	className="submitConfig"
																	onClick={(e) => e.target.form.classList.add('touched')}
																>
																	{__('Connect', 'easy-email-integration')}
																</button>
															</div>
														</div>
													</React.Fragment>
												) : (
													<React.Fragment>
														<div className="configuration-subheader">
															<h4>{configPopShown.name}</h4>
															<h5
																dangerouslySetInnerHTML={{
																	__html: __('is <strong>not installed</strong> or <strong>activated</strong>', 'easy-email-integration'),
																}}
															></h5>
														</div>
														<p className="dependency-not-activated">
															<img src={`${eei.plugin}assets/img/plug.png`} alt={__('Plugin not activated', 'easy-email-integration')} />
															<div>{__('You can integrate with FluentCRM only if it is activated', 'easy-email-integration')}</div>
															{eei.fluentcrm_installed ?
																<a className="eei_install_plugin" href={`${eei.site_url}/wp-admin/plugins.php`}>{__('Activate FluentCRM', 'easy-email-integration')}</a> :
																<a className="eei_install_plugin" href={`${eei.site_url}/wp-admin/plugin-install.php?s=Fluent%20CRM&tab=search&type=term`}>{__('Install FluentCRM', 'easy-email-integration')}</a>
															}
														</p>
													</React.Fragment>
												)}
											</React.Fragment>
										)}

										{configPopShown.key === 'mailpoet' && (
											<React.Fragment>
												{Boolean(eei.mailpoet_activated) ? (
													<React.Fragment>
														<div className="configuration-subheader">
															<h4>
																{__('Configure', 'easy-email-integration')}{' '}
																{configPopShown.name}
															</h4>
															<p
																dangerouslySetInnerHTML={{
																	__html: configPopShown.desc,
																}}
															></p>
														</div>
														<div className="configuration_fields">
															{Object.entries(configPopShown.config).map(
																(field) => (
																	<React.Fragment>
																		{field[1].type === 'multiselect' ? (
																			<React.Fragment>
																				<label className="multiselect">
																					{field[1].label}
																					{field[1].tip && (
																						<React.Fragment>
																							<div
																								className="eei-tooltip"
																								data-place="right"
																								data-offset="{'top': 20, 'right': 20, 'bottom':  20, 'left': 20}"
																								data-multiline={true}
																								data-tip={field[1].tip}
																							>
																								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330">
																									<g>
																										<path d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992     C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008     s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z" />
																										<path d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983     C180,136.725,173.284,130.008,165,130.008z" />
																										<path d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61     c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61     C172.81,71.61,168.95,70.011,165,70.011z" />
																									</g>
																								</svg>
																							</div>
																							<ReactTooltip />
																						</React.Fragment>
																					)}
																					{field[1].desc && (
																						<small dangerouslySetInnerHTML={{
																							__html: field[1].desc,
																						}}></small>
																					)}
																				</label>
																				<div className="multiselect-wrapper">
																					<div
																						className={`multiselect-inputmock ${activeMultiselect === field[0]
																								? 'active'
																								: ''
																							}`}
																						onClick={(e) =>
																							setActiveMultiselect((prev) =>
																								Boolean(prev) ? '' : field[0]
																							)
																						}
																					>
																						{configPopShown.config[field[0]].value
																							.length
																							? configPopShown.config[
																								field[0]
																							].value.map((item) => (
																								<span>
																									{field[0] === 'lists' && (
																										<React.Fragment>
																											{
																												eei.mailpoet_lists.find(
																													(list) =>
																														item === list.id
																												).name
																											}
																										</React.Fragment>
																									)}
																								</span>
																							))
																							: field[1].placeholder}
																					</div>
																					{field[0] === 'lists' && (
																						<ul
																							className={`multiselect-options ${activeMultiselect &&
																									activeMultiselect === field[0]
																									? 'active'
																									: ''
																								}`}
																						>
																							{eei.mailpoet_lists.map((list) => (
																								<li
																									key={list.id}
																									onClick={() => {
																										multiselectChangeHandler(
																											field[0],
																											list.id
																										);
																										setActiveMultiselect('');
																									}}
																								>
																									{list.name}
																								</li>
																							))}
																						</ul>
																					)}
																				</div>
																			</React.Fragment>
																		) : (
																			<label>
																				{field[1].label}
																				<input
																					type="text"
																					name={field[0]}
																					placeholder={field[1].placeholder}
																					value={
																						configPopShown.config[field[0]].value
																					}
																					onChange={configChangeHandler}
																					required
																				/>
																			</label>
																		)}
																	</React.Fragment>
																)
															)}
															<div className="text-right">
															{getActiveIntegration.includes(configPopShown.name) === true ? 
																<button
																	type="button"
																	className="disableConfig"
																	onClick={deactivateIntegration}
																>
																	{__('Disable', 'easy-email-integration')}
																</button>
																:""}

																<button
																	type="submit"
																	className="submitConfig"
																	onClick={(e) => e.target.form.classList.add('touched')}
																>
																	{__('Connect', 'easy-email-integration')}
																</button>
															</div>
														</div>
													</React.Fragment>
												) : (
													<React.Fragment>
														<div className="configuration-subheader">
															<h4>{configPopShown.name}</h4>
															<h5
																dangerouslySetInnerHTML={{
																	__html: __('is <strong>not installed</strong> or <strong>activated</strong>', 'easy-email-integration'),
																}}
															></h5>
														</div>
														<p className="dependency-not-activated">
															<img src={`${eei.plugin}assets/img/plug.png`} alt={__('Plugin not activated', 'easy-email-integration')} />
															<div>{__('You can integrate with MailPoet only if it is activated', 'easy-email-integration')}</div>
															{eei.mailpoet_installed ?
																<a className="eei_install_plugin" href={`${eei.site_url}/wp-admin/plugins.php`}>{__('Activate MailPoet', 'easy-email-integration')}</a> :
																<a className="eei_install_plugin" href={`${eei.site_url}/wp-admin/plugin-install.php?s=MailPoet&tab=search&type=term`}>{__('Install MailPoet', 'easy-email-integration')}</a>
															}
														</p>
													</React.Fragment>
												)}
											</React.Fragment>
										)}

										{configPopShown.key !== 'fluentcrm' &&
											configPopShown.key !== 'mailpoet' && (
												<React.Fragment>
													<div className="configuration-subheader">
														<h4>
															{__('Configure', 'easy-email-integration')}{' '}
															{configPopShown.name}
														</h4>
														<p
															dangerouslySetInnerHTML={{
																__html: configPopShown.desc,
															}}
														></p>
													</div>
													<div className="configuration_fields">


														{Object.entries(configPopShown.config).map(
															(field) => (
																<React.Fragment>
																	<label>
																		{field[1].label}
																		{field[1].tip && (
																			<React.Fragment>
																				<div
																					className="eei-tooltip"
																					data-place="right"
																					data-offset="{'top': 20, 'right': 20, 'bottom':  20, 'left': 20}"
																					data-multiline={true}
																					data-tip={field[1].tip}
																				>
																					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330">
																						<g>
																							<path d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992     C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008     s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z" />
																							<path d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983     C180,136.725,173.284,130.008,165,130.008z" />
																							<path d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61     c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61     C172.81,71.61,168.95,70.011,165,70.011z" />
																						</g>
																					</svg>
																				</div>
																				<ReactTooltip />
																			</React.Fragment>
																		)}
																		{field[1].desc && (
																			<small dangerouslySetInnerHTML={{
																				__html: field[1].desc,
																			}}></small>
																		)}
																	</label>
																	{field[1].type === 'upload_file' ?
																		<MediaUpload
																			onSelect={(media) =>
																				console.log(media)
																			}
																			multiple={false}
																			allowedTypes={['json']}
																			value={'nothing'}
																			render={({ open }) => (
																				<Button onClick={open}>{__('Open Media Library', 'easy-email-integration')}</Button>
																			)}
																		/>
																		: <input
																			type="text"
																			name={field[0]}
																			placeholder={field[1].placeholder}
																			value={configPopShown.config[field[0]].value}
																			onChange={configChangeHandler}
																			required
																		/>
																	}
																</React.Fragment>
															)
														)}

														<div className="text-right">
														{getActiveIntegration.includes(configPopShown.name) === true ? 
															<button
																type="button"
																className="disableConfig"
																onClick={deactivateIntegration}
															>
																{__('Disable', 'easy-email-integration')}
															</button>
															:""}

															<button
																type="submit"
																className="submitConfig"
																onClick={(e) => e.target.form.classList.add('touched')}
															>
																{__('Connect', 'easy-email-integration')}
															</button>
														</div>
													</div>
												</React.Fragment>
											)}
									</React.Fragment>
								) : (
									<React.Fragment>
										<div className="configuration-subheader">
											<h4>
												{__('Configure', 'easy-email-integration')}{' '}
												{configPopShown.name}
											</h4>
											<p
												dangerouslySetInnerHTML={{
													__html: configPopShown.desc,
												}}
											></p>
										</div>
										<div className="configuration_fields">
											<div className="text-right">
											{getActiveIntegration.includes(configPopShown.name) === true ? 
												<button
													type="button"
													className="disableConfig"
													onClick={deactivateIntegration}
												>
													{__('Disable', 'easy-email-integration')}
												</button>
												:""}
												<button
													type="submit"
													className="submitConfig"
													onClick={(e) => e.target.form.classList.add('touched')}
												>
													{__('Connect', 'easy-email-integration')}
												</button>
											</div>
										</div>
									</React.Fragment>
								)}
							</form>
						</div>
					)}
				</div>
			</div>
			
		</div>
	);
};

export default Integrations;
